import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useEffect, useState } from 'react'
import CreatableSelect from 'react-select/creatable'
import subsidiariesApi from 'services/api/subsidiaries'

const EditCSMTagsDialog = ({ onClose }) => {
  const [isLoadingTags, setIsLoadingTags] = useState(true)
  const [isLoadingDefinitions, setIsLoadingDefinitions] = useState(true)

  const [isErred, setIsErred] = useState(false)

  const [tagDefinitions, setTagDefinitions] = useState([])
  const [tags, setTags] = useState([])

  useEffect(() => {
    subsidiariesApi.csmTags.definitions
      .get()
      .then(definitions => {
        setIsLoadingDefinitions(false)
        setTagDefinitions(definitions)
      })
      .catch(() => {
        setIsLoadingDefinitions(false)
        setIsErred(true)
      })
  }, [])

  useEffect(() => {
    subsidiariesApi.csmTags
      .get()
      .then(tags => {
        setIsLoadingTags(false)
        setTags(tags)
      })
      .catch(() => {
        setIsLoadingTags(false)
        setIsErred(true)
      })
  }, [])

  function handleSave() {
    subsidiariesApi.csmTags
      .update({ tags })
      .then(() => {
        onClose()
      })
      .catch(() => {
        setIsErred(true)
      })
  }

  return (
    <ConfirmationDialog
      title={'Edit CSM Tags'}
      theme={'blacklist'}
      positiveMessage="Save"
      negativeMessage="Cancel"
      onClose={onClose}
      onReject={onClose}
      allowOverflow={true}
      maxWidth={700}
      onConfirm={handleSave}
    >
      <div style={{ paddingTop: 20, width: 600 }}>
        {(isLoadingDefinitions || isLoadingTags) && <LoadingIndicator />}
        {!isLoadingDefinitions && !isLoadingTags && !isErred && (
          <CreatableSelect
            isMulti
            value={tags.map(t => ({ label: t.name, value: t.id }))}
            options={tagDefinitions.map(t => ({ label: t.name, value: t.id }))}
            styles={{
              control: base => ({
                ...base,
                paddingTop: 4,
                paddingBottom: 4
              }),
              multiValue: base => ({
                ...base,
                margin: 4,
                backgroundColor: '#F2F8FF',
                boxShadow: '0px 0px 0px 1px #CCDFEB'
              }),
              multiValueLabel: base => ({
                ...base,
                color: '#2B6CB0',
                fontWeight: 500,
                fontSize: 13
              })
            }}
            onChange={selectedOptions =>
              setTags(selectedOptions.map(o => ({ id: o.value, name: o.label })))
            }
            onCreateOption={newOption => {
              setTags([...tags, { name: newOption }])
            }}
          />
        )}
      </div>
    </ConfirmationDialog>
  )
}

export default EditCSMTagsDialog
